import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import TeacherAdd from "./TeacherAdd";
import TeacherEdit from "./TeacherEdit";
import log from "../lib/log";
import { loginState, configState } from "../lib/State";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import CenterSelect from "./CenterSelect";
import pr from "../lib/pr";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function Teacher() {
    const [login, setLogin] = useState(loginState);
    const [loaded, setLoaded] = useState(false);
    const [rows, setRows] = useState([]);
    const [seq, setSeq] = useState(0);
    const [showAdd, setShowAdd] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const token = localStorage.getItem("token");
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [popPhone, setPopPhone] = useState("Hello");
    const [centers, setCenters] = useState([]);
    const [tcid, setTcid] = useState("");
    const [teacher, setTeacher] = useState([]);

    // 폼 데이타
    const [data, setData] = useState({
        tcid: "",
    });

    const onHandleData = (e) => {
        setData((state) => {
            return { ...state, [e.target.name]: e.target.value };
        });
    };

    const open = Boolean(anchorEl);

    const onResetDeviceClick = (e) => {
        alert("?");
    };

    const columns = [
        { field: "id", headerName: "id", hide: true },
        { field: "regdate", headerName: "등록", width: 130, align: "center" },
        {
            field: "name",
            headerName: "이름",
            align: "center",
            width: 120,
            renderCell: (params) => {
                return (
                    <Typography
                        sx={{ p: 1 }}
                        onMouseEnter={(event) => onPopoverOver(event, params.row.phone)}
                        onMouseOut={onPopoverOut}
                    >
                        {params.row.name}
                    </Typography>
                );
            },
        },
        { field: "phone", headerName: "연락처", width: 130, align: "center" },
        { field: "center", headerName: "센터명", width: 200, align: "left" },
        { field: "active", headerName: "수업여부", width: 100, align: "center" },
        {
            field: "edit",
            headerName: "정보수정",
            width: 120,
            align: "center",
            sortable: false,
            renderCell: (params) => {
                return (
                    <Button
                        value={params.row.id}
                        variant="contained"
                        onClick={onEditClick}
                    >
                        수정
                    </Button>
                );
            },
        },
    ];

    // const rows = [
    //   {
    //     id: 1,
    //     name: "Snow",
    //     phone: "000-0000-0000",
    //     sex: "남",
    //     age: 35,
    //     weight: 55,
    //   }
    // ];

    const onCloseAddPop = () => {
        setShowAdd(false);
        load_data();
    };

    const onOpenAdd = () => {
        setShowAdd(true);
    };

    // 로그인 > 센터코드 확인 > 데이타로드
    useEffect(() => {
        if (login.level === "100" || login.level === "500") {
            if (data.tcid !== "") {
                load_data();
            }
        }
    }, [login.level, data.tcid]);

    // 리스트
    const load_data = async () => {
        console.log("load_data");
        let result = await axios.post(configState.api + "/gympass_admin/teacher", {
            token: token,
            cid: login.cid,
            level: login.level,
            mcd: login.mcd,
            tcid: tcid,
            name: data.name,
            phone: data.phone,
        });
        log(result.data);
        if (result.data.success === 1) {
            setRows(result.data.rows);
        } else {
            Swal.fire(result.data.msg);
            return;
        }
    };

    // ======================= //
    // 로그인
    // ======================= //
    const start = async () => {
        let result;
        result = await get_login();
        setLogin(result.data.login);
        result = await is_admin(result.data.login);
        if (!result) {
            window.location.href = "/";
        }
        setLoaded(true);
    };
    useEffect(() => {
        start();
    }, []);

    // 팝업처리
    const onPopoverOver = (event, message) => {
        setPopPhone(message);
        setAnchorEl(event.currentTarget);
    };

    const onPopoverOut = (event) => {
        setAnchorEl(null);
    };

    const onSearchClick = async () => {
        load_data();
    };

    // 수정팝업
    const onEditClick = (e) => {
        setSeq(e.target.value);
        onOpenEditPop();
    };

    const onOpenEditPop = () => {
        setShowEdit(true);
    };

    const onCloseEditPop = () => {
        setShowEdit(false);
        load_data();
    };

    // 리스트
    useEffect(() => {
        if (loaded && tcid !== "") {
            load_data();
        }
    }, [loaded, tcid]);

    return (
        <>
            {loaded === false ? (
                <Loading></Loading>
            ) : (
                <Layout login={login}>
                    <Popover
                        id="mouse-over-popover"
                        sx={{
                            pointerEvents: "none",
                        }}
                        open={open}
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "left",
                        }}
                        transformOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                        }}
                        onClose={onPopoverOut}
                        disableRestoreFocus
                    >
                        <Typography sx={{ p: 1 }}>{popPhone}</Typography>
                    </Popover>

                    <h3
                        css={css`
                        margin-top: 10px;
                        `}
                    >
                        강사관리
                    </h3>
                    <Box
                        css={css`
                        max-width: 1300px;
                        display: flex;
                        align-items: center;
                        `}
                    >
                        {/* 센터명 */}
                        <CenterSelect
                            login={login}
                            tcidParent={tcid}
                            setTcidParent={setTcid}
                        />
                        <Box sx={{ flexGrow: 1 }}></Box>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={onOpenAdd}
                        >
                            강사추가
                        </Button>
                    </Box>

                    <Box display="flex" sx={{ mt: 1 }}>
                        {/* 이름 */}
                        <Box>
                            <TextField
                                sx={{ width: 120 }}
                                name="name"
                                label="이름"
                                size="small"
                                onChange={onHandleData}
                                autoComplete="off"
                            ></TextField>
                        </Box>

                        {/* 연락처 */}
                        <Box>
                            <TextField
                                sx={{ width: 160, ml: 1 }}
                                name="phone"
                                label="연락처"
                                size="small"
                                onChange={onHandleData}
                                autoComplete="off"
                            ></TextField>
                        </Box>
                        <Button
                            sx={{ ml: 1 }}
                            variant="contained"
                            onClick={onSearchClick}
                            size="small"
                        >
                            조회
                        </Button>
                    </Box>

                    <Box sx={{ mt: 1 }}></Box>

                    <DataGrid
                        css={css`
                        max-width: 1300px;
                        min-height: 600px;
                        `}
                        rows={rows}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[5]}
                        checkboxSelection={false}
                        onCellClick={(p, e) => {
                            setSeq(p.id);
                        }}
                    />
                    {console.log(seq)}

                    <Dialog
                        open={showAdd}
                        fullWidth={true}
                        maxWidth="md"
                        TransitionComponent={Transition}
                        onClose={() => { }}
                    >
                        <AppBar sx={{ position: "static" }}>
                            <Toolbar>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography style={{ fontSize: 18 }}>강사추가</Typography>
                                </Box>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    onClick={onCloseAddPop}
                                    aria-label="close"
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <TeacherAdd
                            tcidParent={tcid}
                            login={login}
                            onCloseAddPop={onCloseAddPop}
                        ></TeacherAdd>
                    </Dialog>

                    <Dialog
                        open={showEdit}
                        TransitionComponent={Transition}
                        onClose={() => { }}
                        maxWidth="md"
                    >
                        <AppBar sx={{ position: "static" }}>
                            <Toolbar>
                                <Box sx={{ flexGrow: 1 }}>
                                    <Typography style={{ fontSize: 18 }}>강사수정</Typography>
                                </Box>
                                <IconButton
                                    edge="start"
                                    color="inherit"
                                    onClick={onCloseEditPop}
                                    aria-label="close"
                                >
                                    <CloseIcon />
                                </IconButton>
                            </Toolbar>
                        </AppBar>
                        <TeacherEdit
                            login={login}
                            seq={seq}
                            onClosePop={onCloseEditPop}
                        ></TeacherEdit>
                    </Dialog>
                </Layout>
            )}
        </>
    );
}

export default Teacher;
